import { showSuccessMessage } from '../../../../../app/tools';
import { Card, CardBody, CardTitle } from '../../../../../components';
import UpdateLessonLevels from './UpdateLessonLevels';


export function LessonLevels() {
  

  return (
    <Card>
      <CardTitle>
        <h6 className="text-light m-0">Edit Lesson Details</h6>
      </CardTitle>
      <CardBody>
        <UpdateLessonLevels/>
      </CardBody>
    </Card>
  )
}

export default LessonLevels
